import { Paper, Table } from "@mantine/core";
import { useHeldEmailTableSelection } from "../../../hooks/admin/useHeldEmailTableSelection";
import { HeldEmailQueueEmptyState } from "./HeldEmailQueueEmptyState";
import { HeldEmailQueueTableBody } from "./HeldEmailQueueTableBody";
import { HeldEmailQueueTableHeader } from "./HeldEmailQueueTableHeader";
import { HeldEmailQueueTableModel } from "./heldEmailQueueTableModel";

export function HeldEmailQueueTable({
  model,
}: {
  model: HeldEmailQueueTableModel;
}) {
  const selection = useHeldEmailTableSelection(model);
  if (!model.emails.length)
    return <HeldEmailQueueEmptyState filtered={model.filtered} />;
  return (
    <Paper withBorder>
      <Table.ScrollContainer minWidth={1000}>
        <Table striped highlightOnHover verticalSpacing="md">
          <HeldEmailQueueTableHeader selection={selection} />
          <HeldEmailQueueTableBody model={{ ...model, selection }} />
        </Table>
      </Table.ScrollContainer>
    </Paper>
  );
}
